<template>
  <div class="Case">
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li class="font-white">案例</li>
        </ul>
        <h1>案例中心</h1>
      </div>
    </div>
    <key-case></key-case>
    <all-case></all-case>
  </div>
</template>

<script>
import KeyCase from "../compents/KeyCase";
import AllCase from "../compents/AllCase";
export default {
  components: {
    KeyCase,AllCase
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.other-banner {
  background: url("@/../../assets/img/banner/banner3.jpg");
}
</style>
